import dayjs from 'dayjs'
import { CustomFieldType } from '~/types/graphql'

export type CustomFieldAnswer = {
  id: string
  key: string
  label: string
  type: CustomFieldType
  value: string | number | boolean | string[]
}

/**
 * The API sends a serialized JSON array rather than a typed list, because the
 * value union depends on the field type.
 */
export const parseCustomFieldValues = (
  serialized?: string | null
): CustomFieldAnswer[] => {
  if (!serialized) {
    return []
  }

  try {
    const parsed = JSON.parse(serialized)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

export const formatCustomFieldValue = (answer: CustomFieldAnswer): string => {
  if (Array.isArray(answer.value)) {
    return answer.value.join(', ')
  }

  if (typeof answer.value === 'boolean') {
    return answer.value ? 'Yes' : 'No'
  }

  if (answer.type === CustomFieldType.Date && answer.value) {
    // dayjs reads YYYY-MM-DD as a local calendar day. `new Date` reads it as
    // UTC midnight, which renders the previous day west of UTC.
    const date = dayjs(String(answer.value))
    return date.isValid() ? date.format('M/D/YYYY') : String(answer.value)
  }

  return String(answer.value)
}
